<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Header -->
    <div class="bg-white shadow-sm border-b">
      <div class="max-w-4xl mx-auto px-4 py-6">
        <div class="flex items-center justify-between">
          <h1 class="text-2xl font-bold text-gray-900">
            {{ $t('documents.serviceTerms') }}
          </h1>
          <div class="flex items-center space-x-4">
            <select 
              v-model="currentLang" 
              @change="switchLanguage"
              class="px-3 py-2 border border-gray-300 rounded-md text-sm font-medium bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="ru">Русский</option>
              <option value="kk">Қазақша</option>
            </select>
            <router-link 
              to="/" 
              class="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors text-sm font-medium"
            >
              {{ $t('common.back') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- PDF Viewer -->
    <div class="max-w-6xl mx-auto px-4 py-8">
      <div class="bg-white rounded-lg shadow-lg overflow-hidden">
        <div class="p-4 bg-gray-100 border-b">
          <h2 class="text-lg font-semibold text-gray-800">
            {{ currentLang === 'ru' ? 'Порядок и сроки оказания услуг' : 'Қызмет көрсету тәртібі мен мерзімдері' }}
          </h2>
        </div>
        <div class="p-4">
          <!-- PDF Embed -->
          <div class="w-full" style="height: 800px;">
            <embed 
              :src="pdfUrl" 
              type="application/pdf" 
              width="100%" 
              height="100%"
              class="rounded border"
            />
          </div>
          
          <!-- Fallback for browsers that don't support PDF embed -->
          <div class="mt-4 text-center">
            <a 
              :href="pdfUrl" 
              download 
              class="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium"
            >
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
              {{ $t('documents.downloadPdf') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceTerms',
  data() {
    return {
      currentLang: 'ru'
    }
  },
  computed: {
    pdfUrl() {
      return this.currentLang === 'ru' 
        ? '/service_terms_ru.pdf'
        : '/service_terms_kk.pdf'
    }
  },
  created() {
    // Устанавливаем язык из текущей локали
    this.currentLang = this.$i18n.locale || 'ru'
  },
  methods: {
    switchLanguage() {
      // Обновляем PDF при смене языка
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
/* Дополнительные стили если нужны */
</style>
